export default function SectionText(props:any){
    return <div className={`${props.className} make-font-500`}>{props.children}</div>
}